import { cn } from '@/lib/utils';

interface PlatformLogoProps {
  variant?: 'purple' | 'green' | 'white';
  className?: string;
}

export function PlatformLogo({ variant = 'purple', className }: PlatformLogoProps) {
  const colors = {
    purple: 'hsl(258, 90%, 66%)',
    green: '#10b981',
    white: '#ffffff',
  };

  return (
    <svg
      viewBox="-40 -40 5520 6320"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
      shapeRendering="geometricPrecision"
      className={cn('h-4 w-4', className)}
    >
      <g
        transform="translate(0,6240) scale(1,-1)"
        fill={colors[variant]}
        fillRule="evenodd"
        stroke={colors[variant]}
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M2170 6004 c-289 -117 -642 -261 -785 -318 -987 -399 -1348 -546 -1354 -551 -12 -12 -6 -1064 7 -1280 53 -869 175 -1406 429 -1895 162 -312 365 -584 642 -861 314 -313 659 -573 1098 -826 198 -114 481 -253 515 -253 36 0 424 198 621 317 404 246 697 471 983 757 313 314 501 569 675 916 90 181 209 490 209 544 0 21 -572 268 -587 253 -2 -2 -19 -51 -37 -109 -151 -464 -370 -821 -721 -1171 -267 -267 -588 -499 -1042 -751 l-103 -57 -137 77 c-599 337 -999 666 -1310 1079 -112 148 -289 455 -262 455 10 0 845 -334 1114 -446 151 -63 232 -109 443 -247 l152 -100 103 68 c109 72 336 241 452 335 408 332 607 629 665 992 10 63 10 81 0 93 -21 26 -216 131 -325 176 -55 23 -154 65 -220 94 -66 29 -262 112 -435 185 -173 73 -418 176 -545 230 -126 53 -247 103 -268 111 -35 12 -38 16 -35 49 3 35 3 35 133 88 72 30 204 85 294 123 90 38 169 69 175 69 6 0 61 -21 121 -46 128 -53 1948 -791 2268 -919 119 -49 220 -86 222 -83 15 14 58 415 75 693 31 510 35 1304 6 1339 -6 7 -213 95 -461 194 -247 100 -596 240 -775 312 -179 73 -552 223 -830 335 -278 112 -527 213 -553 224 -27 12 -58 20 -70 20 -12 -1 -258 -97 -547 -215z m1235 -737 c363 -146 820 -331 1015 -409 l355 -144 3 -314 c1 -173 0 -330 -3 -348 -6 -31 -9 -33 -33 -27 -23 6 -601 237 -1746 700 l-288 116 -152 -64 c-83 -36 -322 -136 -531 -222 -567 -234 -588 -247 -600 -377 -8 -86 11 -549 25 -623 15 -75 51 -136 97 -168 23 -15 97 -49 165 -76 161 -64 655 -269 883 -366 208 -88 421 -189 483 -228 39 -25 41 -29 31 -50 -24 -44 -156 -171 -270 -257 l-116 -89 -48 25 c-75 41 -159 75 -1060 436 -467 187 -852 342 -854 344 -6 5 -28 157 -45 304 -34 296 -48 568 -50 925 l-1 360 115 46 c689 276 1839 740 1890 763 19 9 44 14 55 13 11 -2 317 -124 680 -270z"/>
      </g>
    </svg>
  );
}
